export const DEFAULT_TEXT_ABOVE_BUTTON = `
<p><b>Congratulations {{registrantName}}!</b></p>
<br/>
<p>
	You’ve won <b>{{ticketsNumber}}</b> tickets to <b>{{eventName}}</b> on <b>{{eventDate}}</b> at Stern Grove Festival through our lottery system!
	<b>YOU MUST CLAIM YOUR TICKET WITHIN 72 HOURS.</b>
	The deadline to claim is <b>{{expirationDate}}.</b>
	After that, any unclaimed tickets will be released to other fans.
</p>
<br/>

<p><b>HOW TO CLAIM YOUR TICKETS</b></p>
<ol style="margin: 0 0 0 20px; padding-left: 12px;">
	<li>Click the "Claim Tickets" button below.</li>
	<li>You will be redirected to the Claim Screen where you can immediately download your tickets.</li>
	<li>They will also be emailed directly to you.</li>
</ol>
<br/>

<p style="text-align: center;"><b>We’re thrilled you’ll be joining us! It’s going to be a special one. ✨</b></p>
`.trim();

export const DEFAULT_TEXT_BELOW_BUTTON = `
<p>If you have trouble claiming your tickets or do not receive the email with the PDFs within 24 hours of claiming please <a href="https://www.sterngrove.org/ticket-info">visit this page for detailed information</a>.</p>
<br/>
`.trim();
